import { DEFAULT_DECIMAL_SEPARATOR } from '../constants/defaultDecimalSeparator'
import { sanitizeNumberString } from '../sanitizeNumberString'
import { LocaleSeparators } from '../types/LocaleSeparators'

export const strictParseToNumber = (input: string, separators: LocaleSeparators): number => {
  const { decimalSeparator } = separators
  const sanitizedNumber = sanitizeNumberString(input, decimalSeparator)

  return parseFloat(sanitizedNumber.replace(decimalSeparator, DEFAULT_DECIMAL_SEPARATOR) || '0')
}
